export default {
  mesas_diretoras: [],
  mesa_diretora: {},
  pagination: {},
};
